import api from './axios';

export const getServices = (params) =>
  api.get('/services', { params }).then((r) => r.data.data);

export const getServiceBySlug = (slug) =>
  api.get(`/services/${slug}`).then((r) => r.data.data);
